import { ApiService } from './api.service';
import type { SORT_ORDER, SuperAdminCreateRequest, SuperAdminListResponse, SuperAdminUser } from '@/types';

const BASE_URL = '/api/v1/users';

class SuperAdminsService extends ApiService {
  async list({
    cursor,
    limit = 10,
    sortBy,
    sortOrder,
  }: {
    cursor?: string;
    limit?: number;
    sortBy?: string;
    sortOrder?: SORT_ORDER;
  } = {}): Promise<SuperAdminListResponse> {
    const params = new URLSearchParams();
    if (cursor) params.set('cursor', cursor);
    if (typeof limit === 'number') params.set('limit', String(limit));
    if (sortBy) params.set('sortBy', sortBy);
    if (sortOrder) params.set('sortOrder', sortOrder);
    const qs = params.toString();
    const { data } = await this.get<SuperAdminListResponse>(`${BASE_URL}${qs ? `?${qs}` : ''}`);
    return data;
  }

  async getById(id: string): Promise<SuperAdminUser> {
    const { data } = await this.get<SuperAdminUser>(`${BASE_URL}/${id}`);
    return data;
  }

  async create(data: SuperAdminCreateRequest): Promise<void> {
    await this.post(BASE_URL, data);
  }

  async update(id: string, data: Partial<SuperAdminCreateRequest>): Promise<void> {
    await this.put(`${BASE_URL}/${id}`, data);
  }

  async remove(id: string): Promise<void> {
    await this.delete(`${BASE_URL}/${id}`);
  }
}

export default new SuperAdminsService();
